import React from 'react';
import { ErrorPage } from './ErrorHandler.styles';
import T from '../i18n/i18n';

export default class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = {hasError: false};
    }
  
    static getDerivedStateFromError(error) {
        return { hasError: true };
    }
  
    componentDidCatch(error, info) {
        console.error(Object.assign({}, error, {component: info, id: this.props.id+"ErrorCatch"}));
    }
  
    render() {
        if (this.state.hasError) {
            return <ErrorPage><T value={"genericError"} /></ErrorPage>;
        }
  
        return this.props.children; 
    }
  }